// extracted by mini-css-extract-plugin
export default {"termsContainer":"Privacy_policy_termsContainer__lM6s9","privacyContainer":"Privacy_policy_privacyContainer__idRLV"};